export const ROUTES = {
  HOME_PAGE: '/',
  SIGNIN: '/signin',
  SIGNUP: '/signup',
  UNAUTHORIZED: '/unauthorized',
  NOTFOUND: '/page-not-found',
  ACTIVATE_ACCOUNT: (userId: string) => `/activate-account/id=${userId}`,
  SUCCESS_ACTIVATE_ACCOUNT: '/success-activate-account',
  DASHBOARD: {
    PAGE: '/dashboard',
    PROFIL_KYC: '/profil/kyc',
  },
  FORMATION: {
    PAGE: '/formation',
    DEFINITIONS: '/formation-definitions',
    OBLIGATION: '/formation-obligations',
    FINANCIER: '/formation-marche-financier',
    MORANJE: '/formation-moranjetrade',
    INTERBANCAIRE: '/formation-marche-interbancaire',
  },
  FORUM: {
    PAGE: '/forum',
    TOPIC: (topicId: string) => `/forum-categorie/${topicId}`,
    POST: (postId: string) => `/forum-post/${postId}`,
    POSTFORM: '/forum/poster',
    POSTSUBJET: (topicId: string) => `/forum/add-subject/${topicId}`,
  },
  TCHAT: {
    PAGE: '/conversations',
  },
  PANEL: {
    ADMIN: {
      UTILISATEUR: '/panel/admin/utilisateur',
      PARTENAIRE: '/panel/admin/partenaire',
      AGENCE: '/panel/admin/agence',
      AGENCE_USERS: '/panel/admin/agence-users',
      GESTION_USERS_PROFIL: '/panel/admin/gestion-utilisateur-profil',
      GESTION_PASSWORD: '/panel/admin/gestion-mdp',
      LOGS: '/panel/admin/logs',
      STATISTICS: '/panel/admin/statistics',
    },
    EMISSION: {
      TITRE: '/panel/emission-titre',
      NEW_TITRE: '/panel/emission-titre-new',
    },
    COMPTABILITE: {
      COMPTE: '/panel/comptabilite/comptes',
      GRAND_LIVRE: '/panel/comptabilite/grand-livre',
      BALANCE_G: '/panel/comptabilite/balance-general',
    },
    CLIENTELE: {
      CLIENTS: '/panel/gestion-clientele/clients',
    },
    REPORTING: {},
    KYC: '/panel/kyc/list',
  },
  ADMIN: {
    PAGE: '/admin',
    PARTNER: (partnerId: string) => `/partner/${partnerId}`,
    AGENCY: (agenceId: string | any) => `/agency/${agenceId}`,
    ADDPARTNER: '/add-partner',
    REPORTING: '/console/reporting',
    CONSOLE: '/console/client',
    PACK: '/console/pack',
    PARAMETER: '/console/parameter',
    ADDAGENCY: (partnerId: string) => `/add-agency/${partnerId}`,
    ADDUSER: (agencyId: string) => `/add-user/${agencyId}`,
  },
  FISCA: {
    PAGE: '/fiscalite-comptabilite',
    COMPTA_FINANCE: '/fiscalite-comptabilite-comptabilite-financiere',
    COMPTA_OBLIG: '/fiscalite-comptabilite-comptabilite-obligation',
    FISCALITE_OBLIG: '/fiscalite-comptabilite-fiscalite-obligation',
    ANALYSE_ETAT: '/fiscalite-comptabilite-analyse-etats',
    RISQUE_FINANCE: '/fiscalite-comptabilite-risque-financiers',
    ETHIQUE_REGL: '/fiscalite-comptabilite-ethique-reglementation',
  },
  REPORTING: {
    PORTEFEUILLE: '/reporting-portefeuille',
    TITRE: '/reporting-titre',
  },
  COURBE: {
    THEORIE: '/courbe-theorie',
    GRAPHES: '/courbe-graphe',
  },
  REGLEMENTATION: {
    REGION: '/reglementation',
  },
  NETWORK: {
    BOURSE: '/network-bourse',
  },
};
